import React, { useEffect, useState, useCallback} from 'react';
import Table from '../components/table/table';
import ProductData from '../data/products.json';
import DisplayModal from '../modals/displayModal/displayModal';
import SubNav from '../components/subNav/subNav';
import { createProductData, updateProductData, deleteProductData, fetchProductData, fetchProductGlobalSearchData, fetchPIDDropdownOption, publishProductDCL, deleteProductDCL, updateProductDCL } from '../api/productsApi';
const { productsData } = { ...ProductData};
import Loader from '../components/loader/loader';
import { exportToExcel } from '../functions/exportToExcel';
import { parseReqBodyNumber } from '../genericFunctions/parseReqBody';
import { NullUndefinedCheck } from '../genericFunctions/nullUndefinedCheck';
import debouce from 'lodash/debounce';
import handle_toast  from '../genericFunctions/toast_Handler';
import { fetchPAI_UsermanualData } from '../api/firmwareApi';

const Product = () => {  
  const [modalVisible, setModalVisible] = useState(false);
  const [dataFetched, setDataFlag] = useState(false);
  const [productData, setProductData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);  
  const accessData = sessionStorage.getItem('accessData') ? JSON.parse(sessionStorage.getItem('accessData'))['Product'] : {};
  
  const toggleModal = () => {
      setModalVisible(!modalVisible);
  }
  // debounce call
  const debouncedCall = useCallback(
    debouce(()=> {
      fetchProducts();
    }, 500), //Adjusting the delay
    []
  );

  useEffect(() => {
    if (!dataFetched) debouncedCall();
    
    //Clean up the debounce on component unmount
    return () => {
      debouncedCall.cancel();
    };
  }, [dataFetched, debouncedCall])


  const fetchProducts = async () => {
    try{
      const resp = await fetchProductData();
      setDataFlag(true)
      setProductData(resp?.data?.data)
      setIsLoading(false)
      handle_toast({message: `Products data fetched`, status: 'success'})
      if(modalVisible) toggleModal();
    }
    catch(error){
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const fetchGlobalSearch = async (searchFormFields) => {
    try{
      const resp = await fetchProductGlobalSearchData(searchFormFields);
      setIsLoading(false);
      setDataFlag(true)
      setProductData(resp?.data?.globalSearchData)
      handle_toast({message: `Filtered products data fetched`, status: 'success'})
    }
    catch(error){
      setIsLoading(false)
      setDataFlag(true);
      handle_toast(error)
    }
  }

  const handlePublish = async (formData) => {
    setIsLoading(true)
    try{
      const userMaualResp = await fetchPAI_UsermanualData({ 'productId': formData.matterProductId, 'docType': 'User Manual'});
      const manualPath = userMaualResp?.data?.data.length > 0 ? userMaualResp?.data?.data[0].fileLocationPath : ''
      formData['userManualUrl'] = manualPath;
      const resp = await publishProductDCL(parseReqBodyNumber(formData), 'main')
      if(resp) {
        handle_toast({message: `Product Published to DCL`, details: `https://webui.dcl.csa-iot.org/models`, status: 'success'})
        formData.status = 'Published';
        await updateProductData(parseReqBodyNumber(formData))
        setIsLoading(false)
      }
    }
    catch(error){
      setIsLoading(false)
      handle_toast(error)
    }
    
  }
  
  const handleSave = async (formData) => {
    setIsLoading(true)
    let productData, dclResp = null;
    try{
      dclResp = await publishProductDCL(parseReqBodyNumber(formData), 'test')
      if(dclResp){
        formData.status = 'Test';
        productData = await createProductData(parseReqBodyNumber(formData));
        handle_toast({message: `Product created, Published to DCL`, details: `https://webui.dcl.csa-iot.org/models`, status: 'success'})
        fetchProducts();
        fetchPIDDropdownOptionList();
      }
    }
    catch(error){
      handle_toast(error)
      if(NullUndefinedCheck(productData)){
        if(!NullUndefinedCheck(dclResp)) await updateProductDCL(parseReqBodyNumber(formData), 'test')
        setIsLoading(false)
      }
    }
  }

  const handleEdit = async (formData) => {
    setIsLoading(true)
    let dclMainResp, dclTestResp, productResp = null;
    try{
      if(formData.status == 'Published') {
        dclMainResp = await updateProductDCL(parseReqBodyNumber(formData), 'main')
        dclTestResp = await updateProductDCL(parseReqBodyNumber(formData), 'test')
      }
      if(formData.status == 'Test') dclTestResp = await updateProductDCL(parseReqBodyNumber(formData), 'test')
      productResp = await updateProductData(parseReqBodyNumber(formData))
      if(dclMainResp && dclTestResp && productResp && formData.status == 'Published'){
        handle_toast({message: `Product created, Published to DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
        fetchProducts();
      }
      if(dclTestResp && productResp && formData.status == 'Test'){
        handle_toast({message: `Product created, Published to DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
        fetchProducts();
      }
    }
    catch(error){
      handle_toast(error)
      const notUpdatedRecord = productData.filter(obj => obj.id == formData.id)
      if(NullUndefinedCheck(productResp)){
        if(!NullUndefinedCheck(dclMainResp)) await updateProductDCL(parseReqBodyNumber(notUpdatedRecord), 'main')
        if(!NullUndefinedCheck(dclTestResp)) await updateProductDCL(parseReqBodyNumber(notUpdatedRecord), 'test')
        setIsLoading(false)
      }
    }
  }

  const handleDelete = async (formData) => {
    setIsLoading(true)
    let dclMainResp, dclTestResp, productResp = null;
    try{
      if(formData.status == 'Published') {
        dclMainResp = await deleteProductDCL(parseReqBodyNumber(formData), 'main')
        dclTestResp = await deleteProductDCL(parseReqBodyNumber(formData), 'test')
      }
      if(formData.status == 'Test') dclTestResp = await deleteProductDCL(parseReqBodyNumber(formData), 'test')
      productResp = await deleteProductData(parseReqBodyNumber(formData))
      if(dclMainResp && dclTestResp && productResp && formData.status == 'Published'){
        handle_toast({message: `Product deleted, Removed from DCL`, details: `https://webui.dcl.csa-iot.org/models, https://testnet.iotledger.io/models`, status: 'success'})
        fetchProducts();
      }
      if(dclTestResp && productResp && formData.status == 'Test'){
        handle_toast({message: `Product deleted, Removed from DCL`, details: `https://testnet.iotledger.io/models`, status: 'success'})
        fetchProducts();
      }
    }
    catch(error){
      handle_toast(error)
      if(NullUndefinedCheck(productResp)){
        if(!NullUndefinedCheck(dclMainResp)) await publishProductDCL(parseReqBodyNumber(formData), 'main')
        if(!NullUndefinedCheck(dclTestResp)) await publishProductDCL(parseReqBodyNumber(formData), 'test')
        setIsLoading(false)
      }
    }
  }

  const fetchPIDDropdownOptionList = async () => {
    try {
      const dropDownData = sessionStorage.getItem('dropDownData') ? JSON.parse(sessionStorage.getItem('dropDownData')) : {};
      const resp = await fetchPIDDropdownOption();      
      const productFormat = [];
      resp?.data?.data?.map((obj) => {
          productFormat.push({name: obj.matterProductId, label: obj.name, category: obj.category, checked: false}) 
      })
      dropDownData.ProductList = productFormat;
      sessionStorage.setItem('dropDownData', JSON.stringify(dropDownData));
    }
    catch (error) {
      handle_toast(error)
    }
  }

  const excelExport = () => {
    exportToExcel(productData, productsData.productHeaders, 'Product')
  }

  return (
    <>
      <div className='componentContainer'>
        {isLoading && <Loader/>}
        {!isLoading && <SubNav data={productsData.productSubNav} access={accessData} handleModalClick={toggleModal} sendReset={fetchProducts} excelExport={excelExport} handleDDSearch={fetchGlobalSearch}></SubNav>}
        <se-container>
          <se-divider option='vertical'></se-divider>
          <div className='tableContainer'>
            { 
              <Table columns={productsData.productHeaders} access={accessData} body={productData} modalData={productsData.productModalData} uploadModalData={productsData.uploadModalData} onSave={handleEdit} onDelete={handleDelete} page='product' selection={false} onPublish={handlePublish} />
            }
          </div>
        </se-container>
        {modalVisible && <DisplayModal toggleModal={toggleModal} data={productsData.productModalData} source="create" onSave={handleSave} page="product"/>} 
      </div>
    </>
  );
};
export default Product;